import AppCommentsList from './AppCommentsList';

export default AppCommentsList;
